export default __webpack_public_path__ + "static/media/img_smartpay_cover.05dcc733.png";